import {Injectable, OnDestroy} from '@angular/core';
import {
    AbstractFindManyPaginatedService
} from '../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {SubscriptionModel} from '../entity/subscription.model';
import {SubscriptionRepository} from '../../impl/service/ngrx/subscription.repository';
import {SubscriptionDataServiceAdapter} from '../../impl/service/ngrx/subscriptionDataService.adapter';
import {SubscriptionSummaryModel} from "../entity/subscriptionSummary.model";
import {SubscriptionSummaryDataServiceAdapter} from "../../impl/service/ngrx/subscriptionSummaryDataService.adapter";

@Injectable()
export class SubscriptionSummaryPaginatedService extends AbstractFindManyPaginatedService<SubscriptionModel, SubscriptionSummaryModel>
    implements OnDestroy{

    constructor(repository: SubscriptionRepository, dataServiceAdapter: SubscriptionSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    resolveSortKeyLabel(value: string): string {
        return value;
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
